
import { getAuthToken } from './authentication';

export const LoadAPIData = async (ApiUrl) => {
  var bearer = 'Bearer ' + getAuthToken();
  try {
    const response = await fetch(ApiUrl, {
      method: 'GET',
      withCredentials: true,
      credentials: 'include',
      headers: {
        'Authorization': bearer,
        'Content-Type': 'application/json'
      }
    });
    if (response.ok) {
      const data = await response.json();
      return data;
    }
    else {
      try {
        const errorDetail = await response.json().catch(() => ({
          message: 'Unable to parse error response',
        }));
        console.error(response.status + ": " + response.statusText + ":: " + errorDetail);
      } catch (e) {
        console.error(e);
      }


      if (response.status === 401)
        window.location.href = "/login";
      return null;
    }

  } catch (e) {
    console.error(e);
    return null;
  }
}

export const SaveAPIData = async (ApiUrl, Data, Method) => {
  var bearer = 'Bearer ' + getAuthToken();

  try {
    const response = await fetch(ApiUrl, {
      method: Method,
      withCredentials: true,
      credentials: 'include',
      headers: {
        'Authorization': bearer,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(Data),
    });
    if (response.ok) {
      const data = await response.json();
      return { success: true, savedId: data };
    }
    else {
      try {
        const errorDetail = await response.json().catch(() => ({
          message: 'Unable to parse error response',
        }));
        console.error(response.status + ": " + response.statusText + ":: ", errorDetail);
      } catch (e) {
        console.error(e);
      }

      if (response.status === 401)
        window.location.href = "/login";
      return { success: false, savedId: null, errorResponse: response.status };
    }

  } catch (e) {
    console.error(e);
    return { success: false, savedId: null, errorResponse: e.message };
  }
}

export const SaveAPIAnonymousData = async (ApiUrl, Data, Method) => {
  try {
    const response = await fetch(ApiUrl, {
      method: Method,
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(Data),
    });
    console.log(response);
    if (response.ok) {
      const data = await response.json();
      //let data = null;

      return { success: true, savedId: data };
    }
    else {
      try {
        const errorDetail = await response.json().catch(() => ({
          message: 'Unable to parse error response',
        }));
        console.log(response.status + ": " + response.statusText + ":: ", errorDetail);
      } catch (e) {
        console.log(response.status + ": " + response.statusText + ":: ", e.message);
      }

      return { success: false, savedId: null };
    }

  } catch (e) {
    console.error(e);
    return { success: false, savedId: null };
  }
}


export const DeleteAPIData = async (ApiUrl) => {
  //console.log(ApiUrl);
  var bearer = 'Bearer ' + getAuthToken();
  try {
    const response = await fetch(ApiUrl, {
      method: 'DELETE',
      withCredentials: true,
      credentials: 'include',
      headers: {
        'Authorization': bearer,
        'Content-Type': 'application/json'
      }
    });
    if (response.ok) {
      await response.json();
      return true;
    }
    else {
      console.log(response.status + ": " + response.statusText);
      if (response.status === 401)
        window.location.href = "/login";
    }
  } catch (e) {
    console.error(e);
    return false;
  }
}